import { Box, Chip, FormLabel, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import deleteIcon from "../../../../assets/trash1.png";
import editIcon from "../../../../assets/images/actionIcon/edit.png";
import dayjs from "dayjs";
import {
  STAFF_SECOND_PART_DETAILS,
  staffDetailsFormData,
} from "./staffAllFields";
import FormField from "../../../../components/common/FormField";
import {
  deleteOperationStaffAction,
  getSingleOperationStaffAction,
  setAddOperationStaffAction,
  setDeleteOperationStaffAction,
} from "../../../../store/reducers/assignWorkerSlice";
import ManageStaff from "./ManageStaff";
import AbsenceList from "./absence/AbsenceList";
import DeleteAlert from "../../../../components/common/DeleteAlert";

interface StaffDetailsProps {
  selectedId: string | any; // Adjust type as needed
  onEditClick?: () => void;
}

const StaffDetails: React.FC<StaffDetailsProps> = ({
  selectedId,
  onEditClick,
}) => {
  const { singleOperationStaff, deleteOperationStaffResponse,addOperationStaffResponse } = useSelector(
    (state: any) => state.assignWorker
  );
  const { userProfile } = useSelector((state: any) => state?.user);
  const [open, setOpen] = useState(false);
  const [deleteModelShow, setDeleteModelShow] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState<any>(null);

  const dispatch = useDispatch();

  const capEachWord = (str: any) =>
    str
      ? str
          .toLowerCase()
          .split(" ")
          .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
      : "";

  useEffect(() => {
    if (selectedId || deleteOperationStaffResponse || addOperationStaffResponse) {
      dispatch(getSingleOperationStaffAction(selectedId));
      dispatch(setDeleteOperationStaffAction(false));
      dispatch(setAddOperationStaffAction(false));
      setDeleteModelShow(false);
      setOpen(false);
      setSelectedStaff(null);
    }
  }, [dispatch, selectedId, deleteOperationStaffResponse,addOperationStaffResponse]);

  const handleEdit = () => {
    setSelectedStaff(selectedId);
    setOpen(true);
  };

  const handleDeleteAlert = () => {
    setDeleteModelShow(true);
  };

  const handleDelete = () => {
    dispatch(deleteOperationStaffAction(selectedId));
  };

  return (
    <>
      {deleteModelShow && (
        <DeleteAlert
          alertModalShow={deleteModelShow}
          onConfirm={() => {
            handleDelete();
          }}
          message={"Are you sure you want to delete this staff record?"}
          setAlertModelShow={setDeleteModelShow}
        />
      )}
      {open && (
        <ManageStaff
          open={open}
          onHide={() => setOpen(false)}
          title="Manage Staff"
          selectedStaff={selectedStaff}
          action={"edit"}
          setSelectedStaff={setSelectedStaff}
        />
      )}

      <Grid
        container
        sx={{
          width: "100% !important",
          marginTop: "10px",
          padding: "10px !important",
          border: "1px solid #C4CDD5",
          borderRadius: "5px",
          overflow: "hidden",
          background: "#E5F4F1",
          position: "relative",
        }}
      >
        {!singleOperationStaff?.is_deleted && (
          <Box>
            <img
              onClick={handleDeleteAlert}
              src={deleteIcon}
              style={{
                width: "22px",
                height: "22px",
                position: "absolute",
                right: "45px",
                cursor: "pointer",
              }}
              alt="delete"
            />
            <img
              src={editIcon}
              onClick={handleEdit}
              style={{
                width: "20px",
                height: "20px",
                position: "absolute",
                right: "10px",
                cursor: "pointer",
              }}
              alt="edit"
            />
          </Box>
        )}
        {staffDetailsFormData.map((field, index) => (
          <FormField
            key={`${field.id}-${index}`}
            onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
              e.preventDefault()
            }
            {...{
              ...field,
              value: singleOperationStaff
                ? field.id === "licence_expiry_date"
                  ? dayjs(singleOperationStaff[field.id]).isValid()
                    ? dayjs(singleOperationStaff[field.id]).format(
                        userProfile?.dateFormat
                          ? userProfile?.dateFormat
                          : "DD/MM/YYYY"
                      )
                    : ""
                  : field?.id === "is_deleted"
                  ? singleOperationStaff[field.id] === true
                    ? "Deleted"
                    : "Active"
                  : field?.id === "name" || field?.id === "aka_name"
                  ? capEachWord(singleOperationStaff[field.id])
                  : singleOperationStaff[field.id]
                : "",
              // Conditional options for county based on country
              disabled: true,

              variant: "outlined", // Adding this variant prop
              isNonMarginTop: true,
              InputProps: {
                sx:
                  field.type === "text" || field.type === "password"
                    ? { height: "36px" }
                    : {
                        padding: "6px 12px",
                        // height: "36px",
                      },
              },
            }}
          />
        ))}
      </Grid>
      <div
        style={{
          marginTop: "10px",
          padding: "10px 16px",
          border: "1px solid #C4CDD5",
          borderRadius: "5px",
        }}
      >
        <FormLabel sx={{ fontWeight: 600, fontSize: "16px", mb: 1 }}>
          Skills
        </FormLabel>

        <Grid container spacing={1}>
          {singleOperationStaff?.skills?.length > 0 ? (
            singleOperationStaff?.skills?.map((option: any, index: any) => (
              <Grid
                item
                xs={2}
                sx={{ paddingLeft: "0px", marginTop: "6px", fontWeight: 600 }}
                key={index}
              >
                <Chip
                  sx={{ width: "100%", background: "#e5f4f1" }}
                  label={option?.name}
                />
              </Grid>
            ))
          ) : (
            <Grid item xs={2} sx={{ paddingLeft: "0px", marginTop: "6px" }}>
              No skills added
            </Grid>
          )}
        </Grid>
      </div>
      {/*  */}
      <Grid
        container
        sx={{
          width: "100% !important",
          marginTop: "10px",
          padding: "10px !important",
          border: "1px solid #C4CDD5",
          borderRadius: "5px",
          overflow: "hidden",
          background: "#E5F4F1",
          position: "relative",
        }}
      >
        {STAFF_SECOND_PART_DETAILS.map((field, index) => (
          <FormField
            key={`${field.id}-${index}`}
            onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
              e.preventDefault()
            }
            {...{
              ...field,
              value: singleOperationStaff
                ? field.id === "checked_date"
                  ? dayjs(singleOperationStaff[field.id]).isValid()
                    ? dayjs(singleOperationStaff[field.id]).format(
                        userProfile?.dateFormat
                          ? userProfile?.dateFormat
                          : "DD/MM/YYYY"
                      )
                    : ""
                  : field?.id === "name" || field?.id === "aka_name"
                  ? capEachWord(singleOperationStaff[field.id])
                  : singleOperationStaff[field.id]
                : "",
              // Conditional options for county based on country
              disabled: true,
              variant: "outlined", // Adding this variant prop
              isNonMarginTop: true,
              InputProps: {
                sx:
                  field.type === "text" || field.type === "password"
                    ? { height: "36px" }
                    : {
                        padding: "6px 12px",
                        // height: "36px",
                      },
              },
            }}
          />
        ))}
      </Grid>
      {/* Absence list */}
      <AbsenceList selectedId={selectedId} />
    </>
  );
};

export default StaffDetails;
